export default __webpack_public_path__ + "static/media/15t.8dcf9d06.jpg";